import { css } from 'styled-components';

export const ProductSelectStyled = css`
    .product-select {
        .ant-select-selection-item {
            .sku {
                display: none;
            }
        }
    }
`;
